import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    defaultMessage: "Rules",
    id: "kAAlGL",
  },
  addRule: {
    defaultMessage: "Add rule",
    id: "gzM1em",
  },
  catalog: {
    defaultMessage: "Catalog",
    id: "GOdq5V",
  },
  catalogDescription: {
    defaultMessage: "Discount rules for products, collections or categories.",
    id: "ucLtY8",
  },
  checkoutAndOrders: {
    defaultMessage: "Checkout and orders",
    id: "0OAE9q",
  },
  checkoutAndOrdersDescription: {
    defaultMessage: "Discount rules for carts and draft orders.",
    id: "6230rS",
  },
  placeholder: {
    defaultMessage: "Add your first rule to set up a promotion",
    id: "XtlUj6",
  },
  conditions: {
    defaultMessage: "Conditions",
    id: "S8kqP9",
  },
  discountValue: {
    defaultMessage: "Reward value",
    id: "pAwBtz",
  },
  reward: {
    defaultMessage: "Reward",
    id: "PuQb0P",
  },
  catalogRule: {
    id: "A7W4KO",
    defaultMessage: "Catalog rule",
  },
  orderRule: {
    id: "HYK65C",
    defaultMessage: "Order rule",
  },
  ruleSummary: {
    id: "Lrp9WW",
    defaultMessage: "Discount of {value} on the purchase of {conditions} through the {channel}",
  },
  ruleSummaryWithoutConditions: {
    id: "7MUx0T",
    defaultMessage: "Discount of {value} through the {channel}",
  },
  ruleSummaryWithComplexConditions: {
    id: "f1Pj99",
    defaultMessage: "Discount of {value} through the {channel} with {unknown} conditions",
  },
  ruleSummaryMoreItems: {
    id: "B0fwAj",
    defaultMessage: "and {itemsLength} more",
  },
  createRule: {
    id: "9d24PR",
    defaultMessage: "Create rule",
  },
  editRule: {
    id: "v1vJ77",
    defaultMessage: "Edit rule",
  },
  ruleError: {
    id: "zehNKT",
    defaultMessage: "Rule has error, open rule to see details",
  },
  deleteRule: {
    id: "MdFdbd",
    defaultMessage: "Delete rule",
  },
  deleteRuleDescription: {
    id: "XVuPMw",
    defaultMessage: "Are you sure you want to delete this rule?",
  },
  noChannelsSelected: {
    id: "w7jT4W",
    defaultMessage: "No channels selected",
  },
  noHanldedConditions: {
    id: "ckSjjv",
    defaultMessage: "Too complex conditions to display, use playground to see details.",
  },
  noHandledConditionsReminder: {
    id: "E9E5Eh",
    defaultMessage:
      "Please remember that conditions will not be updated when you change the channel.",
  },
  noConditonsCreate: {
    id: "Xu4ST7",
    defaultMessage: "No conditions added, click button bellow to create one",
  },
});
